import { HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { Store } from '@ngrx/store';
import { map, take, tap } from 'rxjs';
import { Router } from '@angular/router';
import { accountActions } from '../store/account/account.actions';
import { MessageService } from 'primeng/api';
import { accountSelector } from '../store/account/account.selectors';
import { enumLicenseStatus } from '../shared/pipes/license-status.pipe';

export const licenseInterceptor: HttpInterceptorFn = (req, next) => {
  const store = inject(Store);
  const router = inject(Router);
  const message = inject(MessageService);
  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) {
        const licenseHeader = event.headers.get('x-nx-license');
        if (licenseHeader) {
          if (licenseHeader !== 'ACTIVE') {
            // if (
            //   !router.url.includes('app/account-support/license') &&
            //   !router.url.includes('app/account-support/account') &&
            //   !router.url.includes('app/account-support/support')
            // ) {
            //   store.dispatch(accountActions.licenseLoad());
            // }

            store.dispatch(accountActions.licenseLoad());

            setTimeout(() => {
              router.navigateByUrl('app/license-inactive');
            }, 1500);

            let currentStatus: string | undefined;
            store.select(accountSelector.licenseStatus).subscribe((x) => {
              currentStatus = x.status;
            });

            if (licenseHeader !== currentStatus) {
              message.clear();
              store.dispatch(accountActions.licenseLoad());
              store.dispatch(accountActions.licenseStatus({ status: licenseHeader as string | undefined }));
              switch (licenseHeader) {
                case enumLicenseStatus.INACTIVE:
                  message.add({
                    severity: 'warn',
                    summary: 'Licenza inattiva',
                    detail: 'La licenza non è attiva. Aspettare la data di attivazione.',
                    life: 0,
                    sticky: true,
                  });
                  break;
                case enumLicenseStatus.EXPIRED:
                  message.add({
                    severity: 'warn',
                    summary: 'Licenza scaduta',
                    detail: 'La licenza è scaduta. Rinnovare la licenza.',
                    life: 0,
                    sticky: true,
                  });
                  break;
                case enumLicenseStatus.NOT_FOUND:
                  console.log(licenseHeader);
                  message.add({
                    severity: 'error',
                    summary: 'Licenza non trovata',
                    detail: 'La licenza non è stata trovata.',
                    life: 0,
                    sticky: true,
                  });
                  break;
                case enumLicenseStatus.ERROR:
                  message.add({
                    severity: 'error',
                    summary: 'Errore',
                    detail: 'Errore nel recupero della licenza.',
                    life: 0,
                    sticky: true,
                  });
                  break;
              }
            }
          } else {
            if (
              !router.url.includes('app/account-support/license') &&
              !router.url.includes('app/account-support/account') &&
              !router.url.includes('app/account-support/support')
            ) {
              store.dispatch(accountActions.licenseLoad());
            }
            store.dispatch(accountActions.licenseStatus({ status: licenseHeader as string | undefined }));
          }
        }

        // else if (licenseHeader === null){
        //   setTimeout(() => {
        //     router.navigateByUrl('app/license-inactive');
        //   }, 1500);

        //   message.add({
        //     severity: 'error',
        //     summary: 'Errore',
        //     detail: 'Errore nel recupero della licenza.',
        //     life: 0,
        //     sticky: true,
        //   });

        // }
      }
    }),
  );
};
